export function FatSecretAttribution({ className = '' }: { className?: string }) {
  return (
    <p className={`text-[10px] leading-snug text-zinc-500 ${className}`}>
      Powered by{' '}
      <a
        href="https://www.fatsecret.com"
        target="_blank"
        rel="noreferrer"
        className="font-medium text-zinc-400 underline decoration-white/20 underline-offset-2 hover:text-zinc-200"
      >
        FatSecret
      </a>
    </p>
  );
}
